var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"swiper-card card-thread"},[_c('h1',[_vm._v(_vm._s(_vm.slide.thread.name))]),_c('div',{staticClass:"clips"},[_c('thread-clip',{key:`inner-clip-${_vm.slide.content.slug}`,attrs:{"isLegacy":"true","element":_vm.slide.content,"paper":_vm.slide.thread}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }